'use client';

import React, { createContext, useContext } from 'react';
import { BrandConfig, BRAND_DEFAULTS } from '@/lib/brand';

const BrandContext = createContext<BrandConfig>(BRAND_DEFAULTS);

/**
 * Reikšmę apskaičiuoja serveris (getServerBrand) ir perduoda kaip prop, tad
 * SSR ir kliento hidratacija naudoja identišką reikšmę — jokio neatitikimo.
 */
export function BrandProvider({
  value,
  children,
}: {
  value: BrandConfig;
  children: React.ReactNode;
}) {
  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>;
}

export function useBrand(): BrandConfig {
  return useContext(BrandContext);
}
